export type ValueFormatter = (value: number, localeCode: string, currencyCode?: string) => string;

export enum MetricType {
  IMPRESSIONS = 'IMPRESSIONS',
  FRAMES = 'FRAMES',
  SOT = 'SOT',
  PRICE_GROSS = 'PRICE_GROSS',
  PRICE_INDEXED = 'PRICE_INDEXED',
}

export interface MetricOption {
  name: string;
  code: MetricType;
}
